var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedexclamationmark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Red exclamation mark"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 20.5125C13 21.8806 14.1251 23 15.5 23C16.8749 23 18 21.8812 18 20.5131V4.48748C18 3.11943 16.8749 2 15.5 2C14.1257 2 13.0006 3.11943 13 4.48748V20.5125Z",
    fill: "url(#paint0_linear_969_23100)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 20.5125C13 21.8806 14.1251 23 15.5 23C16.8749 23 18 21.8812 18 20.5131V4.48748C18 3.11943 16.8749 2 15.5 2C14.1257 2 13.0006 3.11943 13 4.48748V20.5125Z",
    fill: "url(#paint1_linear_969_23100)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 20.5125C13 21.8806 14.1251 23 15.5 23C16.8749 23 18 21.8812 18 20.5131V4.48748C18 3.11943 16.8749 2 15.5 2C14.1257 2 13.0006 3.11943 13 4.48748V20.5125Z",
    fill: "url(#paint2_radial_969_23100)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 20.5125C13 21.8806 14.1251 23 15.5 23C16.8749 23 18 21.8812 18 20.5131V4.48748C18 3.11943 16.8749 2 15.5 2C14.1257 2 13.0006 3.11943 13 4.48748V20.5125Z",
    fill: "url(#paint3_radial_969_23100)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Union_2",
    d: "M13 27.5C13 28.8748 14.1252 30 15.5 30C16.8748 30 18 28.8748 18 27.5C18 26.1252 16.8748 25 15.5 25C14.1252 25 13 26.1252 13 27.5Z",
    fill: "url(#paint4_radial_969_23100)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_969_23100",
    x1: 15.5,
    y1: 23,
    x2: 15.5,
    y2: 2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1F28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F41585"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_969_23100",
    x1: 18.8125,
    y1: 13.125,
    x2: 13,
    y2: 13.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF73A0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419355,
    stopColor: "#FF73A0",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.784946,
    stopColor: "#FF73A0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_969_23100",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.25 3.6875) rotate(90) scale(1.90625)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF73A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF73A0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_969_23100",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.4063 22.75) rotate(90) scale(2.59375)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1E2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED1E2D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_969_23100",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.5625 26.75) rotate(135) scale(3.7565)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.611765,
    stopColor: "#FF3B50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DD3650"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedexclamationmark);
export default __webpack_public_path__ + "static/media/Red exclamation mark.d402ef3cca29efc2c7b33a835d7b6e16.svg";
export { ForwardRef as ReactComponent };